import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("  Cancel ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("  Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_UploadDesign = _resolveComponent("UploadDesign")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "Upload Artworks",
    width: "60%",
    top: "10vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", null, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogVisible = false))
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSave()))
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ARTWORK_SPACES, (artwork, index) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                key: artwork,
                span: 4,
                class: "min-h-[100px]"
              }, {
                default: _withCtx(() => [
                  (_ctx.productVariant[artwork])
                    ? (_openBlock(), _createBlock(_component_UploadImage, {
                        key: 0,
                        setData: _ctx.productVariant,
                        itemIndex: _ctx.productVariant,
                        data: _ctx.productVariant[artwork],
                        artwork: artwork,
                        onCallback: _ctx.callbackDesign,
                        onChangeArtwork: _ctx.changeArtwork,
                        class: "border order-artwork-upload",
                        permission: "all"
                      }, null, 8, ["setData", "itemIndex", "data", "artwork", "onCallback", "onChangeArtwork"]))
                    : (_openBlock(), _createBlock(_component_UploadDesign, {
                        key: 1,
                        onUploaded: _ctx.uploaded,
                        artworkName: artwork,
                        itemIndex: index,
                        disableEdit: false,
                        class: "order-artwork-upload"
                      }, null, 8, ["onUploaded", "artworkName", "itemIndex"]))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}